import { X } from 'lucide-react';
import { pluralize } from '@/utils/pluralize.ts';

/** Polish plural for the "N selected" label. */
const selectedLabel = (count: number): string =>
  pluralize(count, 'zaznaczony', 'zaznaczone', 'zaznaczonych');

interface SelectionCountProps {
  count: number;
  onClear: () => void;
}

/** Left side of the selection bar: how many rows are selected, plus a way out. */
const SelectionCount = ({ count, onClear }: SelectionCountProps) => (
  <div className="flex items-center gap-1.5 pl-1">
    <span className="whitespace-nowrap text-sm font-medium text-neutral-900">
      {selectedLabel(count)}
    </span>
    <button
      type="button"
      onClick={onClear}
      title="Wyczyść zaznaczenie"
      className="rounded-sm p-0.5 text-neutral-500 transition hover:bg-neutral-50 hover:text-neutral-900"
    >
      <X className="size-4" />
    </button>
  </div>
);

export default SelectionCount;
